import React from 'react';
import { connect } from 'react-redux';
import { selectSystem } from '../actions';


class SideBarBs extends React.Component {

	renderList() {

		//Need to assign the following to systems
		//for each system assign specific colors either black or blank, black is the cur system chosen
		//for each system assign their icon classname

		// return this.props.systems.map((system) => {
		// 	return (
		// 		<li className="nav-item cursor-pointer">
		// 			<a onClick={()=> this.props.selectSystem(system)}>
		// 				<i className="fas fa-layer-group" style={allTextStyle}></i>
		// 				<p style={allTextStyle}>All</p>
		// 				<span className="badge badge-secondary" style={{background:"#9429FF"}}>{this.props.systems[0].amount}</span>
		// 			</a>
		// 		</li>
		// 	)
		// })
	}

	render() {
		let myStyleArray = [];
		let isuTextStyle = {
			color: ""
		};
		let agileTextStyle = {
			color: ""
		};
		let sapQnTextStyle = {
			color: ""
		};
		let coupaTextStyle = {
			color: ""
		};
		let samTextStyle = {
			color: ""
		};
		let snowTextStyle = {
			color: ""
		};
		let trackwiseTextStyle = {
			color: ""
		};
		let ivaluaTextStyle = {
			color: ""
		};
		let rceTextStyle = {
			color: ""
		};
		let itTimesheetTextStyle = {
			color: ""
		};
		let concurTextStyle = {
			color: ""
		};
		let neptuneMtTextStyle = {
			color: ""
		};
		let fieldglassTextStyle = {
			color: ""
		};
		let smartrecruitersTextStyle = {
			color: ""
		};
		let neptunePsTextStyle = {
			color: ""
		};
		let myHcmTextStyle = {
			color: ""
		};
		let mesTextStyle = {
			color: ""
		};
		let adobeSignTextStyle = {
			color: ""
		};
		let archibusMovesTextStyle = {
			color: ""
		};
		let workdayTextStyle = {
			color: ""
		};
		let sapPoTextStyle = {
			color: ""
		};
		let workforceTextStyle = {
			color: ""
		};
		let changeRecordTextStyle = {
			color: ""
		};
		let archibusMaintRecordTextStyle = {
			color: ""
		};
		let allTextStyle = {
			color: ""
		};
		if (this.props.curSystem.sysName === "ISU") {
			isuTextStyle = {
				color: "black"
			}
		} else if (this.props.curSystem.sysName === "Agile") {
			agileTextStyle = {
				color: "black"
			}
		} else if (this.props.curSystem.sysName === "All") {
			allTextStyle = {
				color: "black"
			}
		} else if (this.props.curSystem.sysName === "SAP QN") {
			sapQnTextStyle = {
				color: "black"
			}
		} else if (this.props.curSystem.sysName === "Coupa") {
			coupaTextStyle = {
				color: "black"
			}
		}
		else if (this.props.curSystem.sysName === "SAM") {
			samTextStyle = {
				color: "black"
			}
		}
		else if (this.props.curSystem.sysName === "HelpNow") {
			snowTextStyle = {
				color: "black"
			}
		} else if (this.props.curSystem.sysName === "Trackwise") {
			trackwiseTextStyle = {
				color: "black"
			}
		} else if (this.props.curSystem.sysName === "Ivalua") {
			ivaluaTextStyle = {
				color: "black"
			}
		} else if (this.props.curSystem.sysName === "RCE ServiceNow") {
			rceTextStyle = {
				color: "black"
			}
		}
		else if (this.props.curSystem.sysName === "IT Timesheet") {
			itTimesheetTextStyle = {
				color: "black"
			}
		}
		else if (this.props.curSystem.sysName === "Concur") {
			concurTextStyle = {
				color: "black"
			}
		}
		else if (this.props.curSystem.sysName === "Neptune MT") {
			neptuneMtTextStyle = {
				color: "black"
			}
		}
		else if (this.props.curSystem.sysName === "Fieldglass") {
			fieldglassTextStyle = {
				color: "black"
			}
		}
		else if (this.props.curSystem.sysName === "SmartRecruiters") {
			smartrecruitersTextStyle = {
				color: "black"
			}
		}
		else if (this.props.curSystem.sysName === "Neptune PS") {
			neptunePsTextStyle = {
				color: "black"
			}
		}
		else if (this.props.curSystem.sysName === "My HCM") {
			myHcmTextStyle = {
				color: "black"
			}
		}
		else if (this.props.curSystem.sysName === "MES") {
			mesTextStyle = {
				color: "black"
			}
		}
		else if (this.props.curSystem.sysName === "Adobe Sign") {
			adobeSignTextStyle = {
				color: "black"
			}
		}
		else if (this.props.curSystem.sysName === "Archibus Moves") {
			archibusMovesTextStyle = {
				color: "black"
			}
		}
		else if (this.props.curSystem.sysName === "Workday") {
			workdayTextStyle = {
				color: "black"
			}
		}
		else if (this.props.curSystem.sysName === "Purchase Order") {
			sapPoTextStyle = {
				color: "black"
			}
		}
		else if (this.props.curSystem.sysName === "Workforce") {
			workforceTextStyle = {
				color: "black"
			}
		}
		else if (this.props.curSystem.sysName === "Archibus Maint.") {
			archibusMaintRecordTextStyle = {
				color: "black"
			}
		}
		else if (this.props.curSystem.sysName === "Change Record") {
			changeRecordTextStyle = {
				color: "black"
			}
		}



		return (
			<div className="sidebar sidebar-style-2">
				<div className="sidebar-wrapper scrollbar scrollbar-inner">
					<div className="sidebar-content">
						<div className="user cursor-default">
							{/* <div className="avatar-sm float-left mr-2">
								<img src="/assets/img/profile_placeholder.png" alt="..." className="avatar-img rounded-circle"></img>
							</div> */}
							<div className="info">
								<a className="cursor-default" data-toggle="collapse" href="#collapseExample" aria-expanded="true">
									<span>
										Hello
										<span className="user-level">{this.props.user.name}</span>
									</span>
								</a>
								<div className="clearfix"></div>


							</div>
						</div>
						<ul className="nav nav-primary">
							<li className="nav-section">
								<span className="sidebar-mini-icon">
									<i className="fa fa-ellipsis-h"></i>
								</span>
								<h4 className="text-section">Application Totals</h4>
							</li>
							<li className="nav-item cursor-pointer">
								<a onClick={() => this.props.selectSystem(this.props.systems[0])}>
									<i className="fas fa-layer-group" style={allTextStyle}></i>
									<p style={allTextStyle}>All</p>
									<span className="badge badge-secondary" style={{ background: "#9429FF" }}>{this.props.systems[0].amount}</span>
								</a>
							</li>
							<li className="nav-item cursor-pointer">
								<a onClick={() => this.props.selectSystem(this.props.systems[1])}>
									<i className="fas fa-desktop" style={agileTextStyle}></i>
									<p style={agileTextStyle}>ACCS (Agile)</p>
									<span className="badge badge-secondary" style={{ background: "#9429FF" }}>{this.props.systems[1].amount}</span>
								</a>
							</li>
							{/* <li className="nav-item cursor-pointer">
								<a onClick={()=> this.props.selectSystem(this.props.systems[2])}>
									<i className="fas fa-store" style={aribaTextStyle}></i>
									<p style={aribaTextStyle}>Ariba</p>
									<span className="badge badge-secondary" style={{background:"#9429FF"}}>{this.props.systems[2].amount}</span>
								</a>
							</li> */}
							<li className="nav-item cursor-pointer">
								<a onClick={() => this.props.selectSystem(this.props.systems[2])}>
									<i className="fas fa-school" style={isuTextStyle}></i>
									<p style={isuTextStyle}>ISU</p>
									<span className="badge badge-secondary" style={{ background: "#9429FF" }}>{this.props.systems[2].amount}</span>
								</a>
							</li>
							<li className="nav-item cursor-pointer">
								<a onClick={() => this.props.selectSystem(this.props.systems[3])}>
									<i className="fas fa-bell" style={sapQnTextStyle}></i>
									<p style={sapQnTextStyle}>SAP QN</p>
									<span className="badge badge-secondary" style={{ background: "#9429FF" }}>{this.props.systems[3].amount}</span>
								</a>
							</li>
							<li className="nav-item cursor-pointer">
								<a onClick={() => this.props.selectSystem(this.props.systems[4])}>
									<i className="fas fa-store" style={coupaTextStyle}></i>
									<p style={coupaTextStyle}>Coupa</p>
									<span className="badge badge-secondary" style={{ background: "#9429FF" }}>{this.props.systems[4].amount}</span>
								</a>
							</li>
							<li className="nav-item cursor-pointer">
								<a onClick={() => this.props.selectSystem(this.props.systems[5])}>
									<i className="fas fa-address-card" style={samTextStyle}></i>
									<p style={samTextStyle}>SAM</p>
									<span className="badge badge-secondary" style={{ background: "#9429FF" }}>{this.props.systems[5].amount}</span>
								</a>
							</li>
							<li className="nav-item cursor-pointer">
								<a onClick={() => this.props.selectSystem(this.props.systems[6])}>
									<i className="fas fa-laptop" style={snowTextStyle}></i>
									<p style={snowTextStyle}>HelpNow</p>
									<span className="badge badge-secondary" style={{ background: "#9429FF" }}>{this.props.systems[6].amount}</span>
								</a>
							</li>
							<li className="nav-item cursor-pointer">
								<a onClick={() => this.props.selectSystem(this.props.systems[7])}>
									<i className="fas fa-file-signature" style={trackwiseTextStyle}></i>
									<p style={trackwiseTextStyle}>Trackwise</p>
									<span className="badge badge-secondary" style={{ background: "#9429FF" }}>{this.props.systems[7].amount}</span>
								</a>
							</li>
							<li className="nav-item cursor-pointer">
								<a onClick={() => this.props.selectSystem(this.props.systems[8])}>
									<i className="fas fa-file-alt" style={ivaluaTextStyle}></i>
									<p style={ivaluaTextStyle}>Ivalua</p>
									<span className="badge badge-secondary" style={{ background: "#9429FF" }}>{this.props.systems[8].amount}</span>
								</a>
							</li>
							<li className="nav-item cursor-pointer">
								<a onClick={() => this.props.selectSystem(this.props.systems[9])}>
									<i className="fas fa-dollar-sign" style={rceTextStyle}></i>
									<p style={rceTextStyle}>RCE ServiceNow</p>
									<span className="badge badge-secondary" style={{ background: "#9429FF" }}>{this.props.systems[9].amount}</span>
								</a>
							</li>
							<li className="nav-item cursor-pointer">
								<a onClick={() => this.props.selectSystem(this.props.systems[10])}>
									<i className="fas fa-book" style={concurTextStyle}></i>
									<p style={concurTextStyle}>Concur</p>
									<span className="badge badge-secondary" style={{ background: "#9429FF" }}>{this.props.systems[10].amount}</span>
								</a>
							</li>
							<li className="nav-item cursor-pointer">
								<a onClick={() => this.props.selectSystem(this.props.systems[11])}>
									<i className="fas fa-pen-nib" style={neptuneMtTextStyle}></i>
									<p style={neptuneMtTextStyle}>Neptune MT</p>
									<span className="badge badge-secondary" style={{ background: "#9429FF" }}>{this.props.systems[11].amount}</span>
								</a>
							</li>
							<li className="nav-item cursor-pointer">
								<a onClick={() => this.props.selectSystem(this.props.systems[12])}>
									<i className="fas fa-file-invoice-dollar" style={fieldglassTextStyle}></i>
									<p style={fieldglassTextStyle}>Fieldglass</p>
									<span className="badge badge-secondary" style={{ background: "#9429FF" }}>{this.props.systems[12].amount}</span>
								</a>
							</li>
							<li className="nav-item cursor-pointer">
								<a onClick={() => this.props.selectSystem(this.props.systems[13])}>
									<i className="fas fa-brain" style={smartrecruitersTextStyle}></i>
									<p style={smartrecruitersTextStyle}>SmartRecruiters</p>
									<span className="badge badge-secondary" style={{ background: "#9429FF" }}>{this.props.systems[13].amount}</span>
								</a>
							</li>
							<li className="nav-item cursor-pointer">
								<a onClick={() => this.props.selectSystem(this.props.systems[14])}>
									<i className="fas fa-clock" style={itTimesheetTextStyle}></i>
									<p style={itTimesheetTextStyle}>IT Timesheet</p>
									<span className="badge badge-secondary" style={{ background: "#9429FF" }}>{this.props.systems[14].amount}</span>
								</a>
							</li>
							<li className="nav-item cursor-pointer">
								<a onClick={() => this.props.selectSystem(this.props.systems[15])}>
									<i className="fas fa-pen" style={neptunePsTextStyle}></i>
									<p style={neptunePsTextStyle}>Neptune PS</p>
									<span className="badge badge-secondary" style={{ background: "#9429FF" }}>{this.props.systems[15].amount}</span>
								</a>
							</li>
							<li className="nav-item cursor-pointer">
								<a onClick={() => this.props.selectSystem(this.props.systems[16])}>
									<i className="fas fa-clipboard" style={myHcmTextStyle}></i>
									<p style={myHcmTextStyle}>My HCM</p>
									<span className="badge badge-secondary" style={{ background: "#9429FF" }}>{this.props.systems[16].amount}</span>
								</a>
							</li>
							<li className="nav-item cursor-pointer">
								<a onClick={() => this.props.selectSystem(this.props.systems[17])}>
									<i className="fas fa-keyboard" style={mesTextStyle}></i>
									<p style={mesTextStyle}>MES</p>
									<span className="badge badge-secondary" style={{ background: "#9429FF" }}>{this.props.systems[17].amount}</span>
								</a>
							</li>
							<li className="nav-item cursor-pointer">
								<a onClick={() => this.props.selectSystem(this.props.systems[18])}>
									<i className="fas fa-file-signature" style={adobeSignTextStyle}></i>
									<p style={adobeSignTextStyle}>Adobe Sign</p>
									<span className="badge badge-secondary" style={{ background: "#9429FF" }}>{this.props.systems[18].amount}</span>
								</a>
							</li>
							<li className="nav-item cursor-pointer">
								<a onClick={() => this.props.selectSystem(this.props.systems[19])}>
									<i className="fas fa-map-marker-alt" style={archibusMovesTextStyle}></i>
									<p style={archibusMovesTextStyle}>Archibus Moves</p>
									<span className="badge badge-secondary" style={{ background: "#9429FF" }}>{this.props.systems[19].amount}</span>
								</a>
							</li>
							<li className="nav-item cursor-pointer">
								<a onClick={() => this.props.selectSystem(this.props.systems[20])}>
									<i className="fas fa-users" style={workdayTextStyle}></i>
									<p style={workdayTextStyle}>Workday</p>
									<span className="badge badge-secondary" style={{ background: "#9429FF" }}>{this.props.systems[20].amount}</span>
								</a>
							</li>
							<li className="nav-item cursor-pointer">
								<a onClick={() => this.props.selectSystem(this.props.systems[21])}>
									<i className="fas fa-file-alt" style={sapPoTextStyle}></i>
									<p style={sapPoTextStyle}>Purchase Order</p>
									<span className="badge badge-secondary" style={{ background: "#9429FF" }}>{this.props.systems[21].amount}</span>
								</a>
							</li>
							<li className="nav-item cursor-pointer">
								<a onClick={() => this.props.selectSystem(this.props.systems[22])}>
									<i className="fas fa-clock" style={workforceTextStyle}></i>
									<p style={workforceTextStyle}>Workforce</p>
									<span className="badge badge-secondary" style={{ background: "#9429FF" }}>{this.props.systems[22].amount}</span>
								</a>
							</li>
							<li className="nav-item cursor-pointer">
								<a onClick={() => this.props.selectSystem(this.props.systems[23])}>
									<i className="fas fa-file-alt" style={changeRecordTextStyle}></i>
									<p style={changeRecordTextStyle}>Change Record</p>
									<span className="badge badge-secondary" style={{ background: "#9429FF" }}>{this.props.systems[23].amount}</span>
								</a>
							</li>
							<li className="nav-item cursor-pointer">
								<a onClick={() => this.props.selectSystem(this.props.systems[24])}>
									<i className="fas fa-map-marker-alt" style={archibusMaintRecordTextStyle}></i>
									<p style={archibusMaintRecordTextStyle}>Archibus Maint.</p>
									<span className="badge badge-secondary" style={{ background: "#9429FF" }}>{this.props.systems[24].amount}</span>
								</a>
							</li>
						</ul>
					</div>
				</div>
			</div>
		)
	}
};



const mapStateToProps = (state) => {
	//console.log("SIDEBAR state", state);
	return { systems: state.systems, curSystem: state.selectedSystem, user: state.user };
}
export default connect(mapStateToProps, { selectSystem })(SideBarBs);